import React from 'react'
import { css } from '@emotion/react'
import Loader from './loader.inline.svg'

const loaderSvg = css`
  height: 120px;
`

const loadingContainer = css`
  text-align: center;
`

const loaderText = css`
  font-size: 16px;
  font-weight: 500;
`

export default function Loading() {
  return (
    <div id="subapp-loading" css={loadingContainer}>
      <div>
        <Loader css={loaderSvg} />
        <div css={loaderText}>Just a moment, tickling the servers...</div>
      </div>
    </div>
  )
}
